// Questions, options and results-screen copy for onboarding. Answers are saved
// as the exact option strings, so changing wording here changes what is stored.

export const TIMELINE_OPTIONS = ['Within 6 months', '6-12 months', '1-2 years', 'More than 2 years', "I'm not sure yet"];

export const GROWTH_OPTIONS = [
  'Knowing myself and what I need in a relationship',
  'Strengthening my relationship with Allah',
  'Building emotional and communication skills',
  'Becoming financially prepared',
  'Understanding the responsibilities of marriage',
  'Knowing how to navigate the search for a spouse',
];

export const CHALLENGE_OPTIONS = [
  'Knowing where to start',
  'Knowing whether I\'m truly ready',
  'Finding clarity about what I want',
  'Staying consistent with my personal and spiritual growth',
  'Navigating the search without feeling overwhelmed',
  'Feeling alone in the process',
  'Managing practical things like finances',
  "I'm not sure yet",
];

export const SUPPORT_OPTIONS = [
  'Guidance from mentors and experienced members',
  'Structured lessons I can follow at my own pace',
  'A supportive community to talk things through',
  'Daily habits and accountability',
  'Live sessions with experts + Q&A',
  "I'm not sure yet",
];

export const READINESS_SAVINGS = "I'm building my savings";
export const READINESS_DEBT = "I'm working on paying down debt";
export const READINESS_OPTIONS = [
  'I feel financially prepared',
  READINESS_SAVINGS,
  READINESS_DEBT,
  "I'm just getting started",
  "I'm not sure where I stand",
];

// The dashboard thermometer still keys off these two goal types.
export const goalTypeFromReadiness = (readiness) => {
  if (readiness === READINESS_SAVINGS) return 'Build my savings';
  if (readiness === READINESS_DEBT) return 'Pay off debt';
  return null;
};

export const readinessFromGoalType = (goalType) => {
  if (goalType === 'Build my savings') return READINESS_SAVINGS;
  if (goalType === 'Pay off debt') return READINESS_DEBT;
  return '';
};

// Short label shown as "Your growth focus", plus how the "next step" sentence begins.
const GROWTH_COPY = {
  [GROWTH_OPTIONS[0]]: { label: 'Self-awareness', start: 'Gain clarity about who you are and what you need in a partner' },
  [GROWTH_OPTIONS[1]]: { label: 'Spiritual growth', start: 'Deepen your relationship with Allah' },
  [GROWTH_OPTIONS[2]]: { label: 'Emotional readiness & communication', start: 'Build your emotional and communication skills' },
  [GROWTH_OPTIONS[3]]: { label: 'Financial readiness', start: 'Get financially prepared for the responsibilities of marriage' },
  [GROWTH_OPTIONS[4]]: { label: 'Marriage knowledge', start: 'Understand what marriage asks of you' },
  [GROWTH_OPTIONS[5]]: { label: 'Navigating the search', start: 'Approach the search with confidence and intention' },
};

// Members who answered the original onboarding have these older values.
const LEGACY_GROWTH_LABELS = {
  Spiritual: 'Spiritual growth',
  Character: 'Character',
  Financial: 'Financial readiness',
  'Emotional & Self-Knowledge': 'Emotional readiness & self-knowledge',
};

export const growthFocusLabel = (value) => GROWTH_COPY[value]?.label || LEGACY_GROWTH_LABELS[value] || value;

const CHALLENGE_CLOSERS = {
  [CHALLENGE_OPTIONS[0]]: "We'll point you to a first step so you're not guessing.",
  [CHALLENGE_OPTIONS[1]]: 'Your dashboard shows your readiness as you grow.',
  [CHALLENGE_OPTIONS[2]]: 'Take it one reflection at a time.',
  [CHALLENGE_OPTIONS[3]]: 'Small daily habits keep you steady.',
  [CHALLENGE_OPTIONS[4]]: 'Go at a pace that feels steady.',
  [CHALLENGE_OPTIONS[5]]: "You're not doing this alone.",
  [CHALLENGE_OPTIONS[6]]: 'Your financial tracker keeps the practical side simple.',
  [CHALLENGE_OPTIONS[7]]: "There's no pressure to have it figured out.",
};

export const nextStepText = (growth, challenge) => {
  const start = GROWTH_COPY[growth]?.start || 'Keep building your readiness, one step at a time';
  const closer = CHALLENGE_CLOSERS[challenge] || "You're not doing this alone.";
  return `${start}. ${closer}`;
};
